import { ReactNode } from 'react';

import { classNames } from './ui';

export type KpiTone = 'ok' | 'warn' | 'alert';

interface KpiTileProps {
  label: string;
  value: ReactNode;
  hint?: string;
  tone: KpiTone;
}

const KpiTile = ({ label, value, hint, tone }: KpiTileProps) => (
  <div
    className={classNames('rounded-lg border bg-white p-4 shadow-sm dark:bg-slate-800', {
      'border-green-300 dark:border-green-700': tone === 'ok',
      'border-yellow-400 dark:border-yellow-600': tone === 'warn',
      'border-red-400 dark:border-red-600': tone === 'alert',
    })}
  >
    <p className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</p>
    <p
      className={classNames('mt-1 text-2xl font-bold', {
        'text-gray-900 dark:text-gray-100': tone === 'ok',
        'text-yellow-700 dark:text-yellow-400': tone === 'warn',
        'text-red-700 dark:text-red-400': tone === 'alert',
      })}
    >
      {value}
    </p>
    {hint && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
  </div>
);

export default KpiTile;
